module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "hardware-simulator"
  }, [_vm._m(0), _c('div', {
    staticClass: "hw-main-section"
  }, [_c('h3', {
    staticClass: "hw-title align-self-middle"
  }, [_vm._v("Vehicle Status")]), _c('div', {
    staticClass: "hw-main-row align-center align-middle"
  }, [_c('div', {
    staticClass: "hw-plate"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.serial),
      expression: "serial"
    }],
    attrs: {
      "type": "text"
    },
    domProps: {
      "value": (_vm.serial)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.serial = $event.target.value
      }
    }
  })]), _c('div', {
    staticClass: "hw-car",
    class: {
      running: _vm.ignition_status
    }
  }, [_c('img', {
    attrs: {
      "src": "/static/hwsim/model3.png"
    }
  }), _c('label', {
    staticClass: "hw-ignition pulse",
    class: {
      disabled: !_vm.serial || _vm.serial.length < 6, active: _vm.ignition_status
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        return _vm.toggleIgnition()
      }
    }
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.ignition_status),
      expression: "ignition_status"
    }],
    attrs: {
      "type": "checkbox"
    },
    domProps: {
      "checked": Array.isArray(_vm.ignition_status) ? _vm._i(_vm.ignition_status, null) > -1 : (_vm.ignition_status)
    },
    on: {
      "change": function($event) {
        var $$a = _vm.ignition_status,
          $$el = $event.target,
          $$c = $$el.checked ? (true) : (false);
        if (Array.isArray($$a)) {
          var $$v = null,
            $$i = _vm._i($$a, $$v);
          if ($$el.checked) {
            $$i < 0 && (_vm.ignition_status = $$a.concat([$$v]))
          } else {
            $$i > -1 && (_vm.ignition_status = $$a.slice(0, $$i).concat($$a.slice($$i + 1)))
          }
        } else {
          _vm.ignition_status = $$c
        }
      }
    }
  })]), _c('label', {
    staticClass: "hw-doors pulse",
    class: {
      disabled: !_vm.serial || _vm.serial.length < 6, active: _vm.door_status
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        return _vm.toggleDoors()
      }
    }
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.door_status),
      expression: "door_status"
    }],
    attrs: {
      "type": "checkbox"
    },
    domProps: {
      "checked": Array.isArray(_vm.door_status) ? _vm._i(_vm.door_status, null) > -1 : (_vm.door_status)
    },
    on: {
      "change": function($event) {
        var $$a = _vm.door_status,
          $$el = $event.target,
          $$c = $$el.checked ? (true) : (false);
        if (Array.isArray($$a)) {
          var $$v = null,
            $$i = _vm._i($$a, $$v);
          if ($$el.checked) {
            $$i < 0 && (_vm.door_status = $$a.concat([$$v]))
          } else {
            $$i > -1 && (_vm.door_status = $$a.slice(0, $$i).concat($$a.slice($$i + 1)))
          }
        } else {
          _vm.door_status = $$c
        }
      }
    }
  })])]), (_vm.reservation && _vm.reservation.reservation) ? _c('div', {
    staticClass: "hw-on-board"
  }, [(_vm.reservation.reservation.status === 'STARTED') ? _c('p', {
    staticClass: "hw-label active"
  }, [_vm._v("client on board")]) : _c('p', {
    staticClass: "hw-label"
  }, [_vm._v("no client on board")])]) : _vm._e()]), (_vm.reservation && _vm.reservation.reservation) ? _c('div', {
    staticClass: "hw-main-row align-center align-middle hw-data"
  }, [_c('div', {
    staticClass: "hw-column"
  }, [_c('p', [_vm._v("reservation number")]), _c('p', {
    staticClass: "hw-res-number"
  }, [_vm._v(_vm._s(_vm.reservation.reservation.number))])]), _c('div', {
    staticClass: "hw-column"
  }, [_c('p', {
    staticClass: "hw-date"
  }, [_vm._v(_vm._s(_vm.format(_vm.reservation.reservation.start).date))]), _c('p', {
    staticClass: "hw-time"
  }, [_vm._v(_vm._s(_vm.format(_vm.reservation.reservation.start).time))])]), _c('div', {
    staticClass: "hw-column"
  }, [_c('p', {
    staticClass: "hw-date"
  }, [_vm._v(_vm._s(_vm.format(_vm.reservation.reservation.end).date))]), _c('p', {
    staticClass: "hw-time"
  }, [_vm._v(_vm._s(_vm.format(_vm.reservation.reservation.end).time))])]), _c('div', {
    staticClass: "hw-column"
  }, [_c('p', {
    staticClass: "hw-label",
    class: {
      active: _vm.reservation.reservation.status === 'STARTED'
    }
  }, [_vm._v(_vm._s(_vm.reservation.reservation.status))]), _c('p', {
    staticClass: "hw-distance"
  }, [_vm._v(_vm._s(_vm.reservation.reservation.distance) + "km driven")]), _c('p', {
    staticClass: "hw-trips"
  }, [_vm._v(_vm._s(_vm.reservation.reservation.trips_count) + " trips")])])]) : _vm._e()]), _c('div', {
    staticClass: "hw-controls"
  }, [_c('h4', {
    staticClass: "hw-title"
  }, [_vm._v("Trip run simulation")]), _c('p', [_vm._v("you need to open door and switch on engine")]), _c('div', {
    staticClass: "hw-row-center"
  }, [_c('div', {
    staticClass: "hw-column"
  }, [_c('label', [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.trip_distance),
      expression: "trip_distance"
    }],
    attrs: {
      "type": "number",
      "min": "0",
      "max": "999"
    },
    domProps: {
      "value": (_vm.trip_distance)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.trip_distance = $event.target.value
      }
    }
  }), _c('p', [_vm._v("km")])])]), _c('div', {
    staticClass: "hw-column hw-center-column"
  }, [_c('button', {
    staticClass: "hw-wheel-button",
    class: {
      loading: _vm.loading, disabled: !_vm.readyToSend
    },
    on: {
      "click": _vm.sendTrip
    }
  }), _vm._m(1)]), _c('div', {
    staticClass: "hw-column"
  }, [_c('label', [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.fuel_level),
      expression: "fuel_level"
    }],
    attrs: {
      "type": "number",
      "min": "0",
      "max": "100"
    },
    domProps: {
      "value": (_vm.fuel_level)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.fuel_level = $event.target.value
      }
    }
  }), _c('p', [_vm._v("fuel level")])])])])])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "header"
  }, [_c('img', {
    attrs: {
      "src": "/static/hwsim/logo.svg"
    }
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('label', [_c('p', {
    staticClass: "align-self-middle"
  }, [_vm._v("send")])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-333977a9!./~/vue-loader/lib/template-loader.js?raw&engine=pug!./~/vue-loader/lib/selector.js?type=template&index=0!./src/pages/HwSim.vue
// module id = 2393
// module chunks = 1